<template>
	<nav id="sidebar">
		<div class="folder-menu p-2 text-center" @click="toggleMenu">{{ $t('show_menu')}} <font-awesome-icon class="mr-2" :icon="['fas', 'align-justify']" /></div>
		<div v-if="showMenu && showViewMenu == 'program.stage' && stage_tasks" class="program">
			<ul class="list-unstyled folders m-0 border-0">
				<span v-for="task in stage_tasks" :key="task.id">
					<router-link v-if="task.unlocked == true" tag="li" class="pointer" :to="{ name: 'therapy.content', params: {stage: stage_id, task_id: task.id} }">
						<span @click="programRouteClick">
							<font-awesome-icon v-if="task.complete" :icon="['fas', 'check']" class="text-success" />
							<font-awesome-icon v-else :icon="drawIcon(task.item.type)" />
							{{task.display_title?task.display_title:task.item.title}}</span>
					</router-link>
					<li v-else class="locked">
						<font-awesome-icon :icon="['fas', 'lock']" /> {{task.item.title}}
					</li>
				</span>
			</ul>
			<ul class="list-unstyled folders border-top m-0">
				<router-link :to="{ name: 'therapy.display', params: {enrol_id: enrol_id} }" tag="li" class="my-3 ml-2 font-weight-normal pointer">
					<font-awesome-icon class="mr-1" icon="arrow-left" /> {{ $t('courses.overview_back')}}
				</router-link>
				<router-link :to="{ name: 'therapy.display', params: {enrol_id: enrol_id}, query: {actionjump: 'yes'}  }" tag="li" class="my-3 ml-2 font-weight-normal pointer">
					<font-awesome-icon class="mr-1" icon="arrow-left" /> {{ $t('courses.go_to_additional_resources')}}
				</router-link>
			</ul>
			<ul v-if="Object.keys(checkForum).length > 0" class="list-unstyled folders border-top m-0">
				<router-link :to="{ name: 'forums' }" tag="li" class="my-3 ml-2 font-weight-normal pointer">
					<font-awesome-icon class="mr-1" icon="comment-dots" /> {{ $t('forums.forum')}}
				</router-link>
			</ul>
		</div>

		<div v-if="showMenu && showViewMenu == 'messages'" class="messages">
			<ul class="list-unstyled folders m-0 border-0" v-if="folders">
				<Folders v-for="folder in folders" :key="folder.id" :folder="folder"></Folders>
			</ul>
			<ul class="list-unstyled folders border-top m-0">
				<li><router-link :to="{ name: 'messages.folders' }"><font-awesome-icon class="mr-2" icon="cog" /> {{ $t('messages.manage_folders') }}</router-link></li>
			</ul>
		</div>
	</nav>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import { errHandler } from '@/lib/handlers'

export default {
	name: 'SideBar',
	components: {
		Folders: () => import('@/views/Messages/Folders.vue'),
	},
	props: ['task_id'],
	data () {
		return {
			isMobile: false,
			showMenu: true,
			showViewMenu: null,
			windowWidth: window.innerWidth
		}
	},
	created () {
		this.checkRoute();
	},
	mounted() {
		this.isMobile = (window.innerWidth <= 800) ? true : false;
		this.$nextTick(() => window.addEventListener('resize', () => this.windowWidth = window.innerWidth) );
	},
	watch: {
		windowWidth(newWidth, oldWidth) {
			this.isMobile = (newWidth <= 800) ? true : false;
			this.showMenu = (newWidth <= 800) ? false : true;
		}
	},
	methods: {
		...mapActions(['fetchFolders', 'fetchStage']),
		toggleMenu (e) {
			this.showMenu = !this.showMenu;
		},
		checkRoute () {
			this.showViewMenu = null;
			let hideSidebar = false;
			if (this.$route.name && this.$route.name.includes("messages") ) {
				this.inboxJump(this.$route.name);
				this.showViewMenu = 'messages';
			} else if (this.$route.name && this.$route.path.includes("stage") ) {
				if (this.enrollment && !this.$store.state.programs.stage) this.fetchStage({enrol_id: this.enrollment.id, stage_id: this.stage_id});
				this.showViewMenu = 'program.stage';
			}
		},
		inboxJump (routeName) {
			let inbox = (this.typeFolders(40)[0]) ? this.typeFolders(40)[0].id : 0;
			if (routeName == 'messages' && inbox > 0) this.$router.push({ name: 'messages.listing', params: { id: inbox } } );
		},
		drawIcon (type) {
			if (type == 'collections') return ['far', 'file-alt'];
			else if (type == 'slideshows') return ['far', 'image'];
			else if (type == 'pages') return ['far', 'file-alt'];
			else if (type == 'surveys') return ['far', 'file-alt'];
		},
		programRouteClick () { // Forces the Content to Refresh when Side Nav item is clicked
			this.$emit('programRoute');
		},
		link_active (taskId) {
			console.log (">>> LINK ACTIVE!! " + this.task_id)
			return 'pointer' + ((this.task_id == taskId)?' router-link-active':'');
		}
	},
	computed: {
		...mapGetters(['typeFolders']),
		enrol_id () {
			return this.$route.params.enrol_id;
		},
		enrollment () {
			return this.$store.state.programs.enrollments[this.enrol_id];
		},
		stage_id () {
			if (this.$route.params) return this.$route.params.stage_id;
		},
		stage_tasks () {
			if (this.$store.state.programs.stage) return _.orderBy(this.$store.state.programs.stage.tasks, 'position', 'asc');
		},
		checkForum () {
             return (this.$store.state.forums.forums) ? this.$store.state.forums.forums : {};
         },
		folders () {
			if (this.$store.state.messages.folders) {
				let folders = _.filter(this.$store.state.messages.folders, function(f) { return f.parent_folder_id == null });
				return _.orderBy(folders, ['type_id', 'name'], ['desc', 'asc']);
			}
		}
	}
}
</script>
